import { AlertModal, Para } from '@drycut/ui-components';

type Props = {
  error: object | string;
  onClose: () => void;
  open: boolean;
};

export default function DatatransErrorModal({ open, error, onClose }: Props): React.ReactElement {
  return (
    <AlertModal open={open} title="Error" onConfirm={onClose} onClose={onClose}>
      <Para size="2xl">Irgendetwas ist schief gelaufen. Bitte versuche es später nochmal.</Para>

      <Para className="hidden">{JSON.stringify(error)}</Para>
    </AlertModal>
  );
}
